module.exports = __webpack_public_path__ + "img/3diamond-12.e4f19b3d.svg";